import React, { useEffect, useState } from "react";
import "./home.css";
import "../../common/css/layout.css";
import NewsSection from "./NewsSection";
import SocialMediaSection from "./SocialMediaSection";
import { GetLatestNews, GetOlderNews } from '../../common/api/PortcoNewsAPIHelper';
import { PORTCO_TWITTER_LIST_ID, FOUNDER_TWITTER_LIST_ID } from '../../common/util/constants'; 

function Home() {
    const [latestNews, setLatestNews] = useState(null);
    const [olderNews, setOlderNews] = useState(null);

    useEffect(() => {
        const fetchLatestNews = async () => {
            try {
                const latest = await GetLatestNews("latest");
                console.log("Latest News:", latest);
                setLatestNews(latest);
            } catch (error) {
                console.error("Error in fetchLatestNews:", error);
            }
        };
        
        fetchLatestNews();
    }, []);
    
    useEffect(() => {
        const fetchOlderNews = async () => {
            try {
                const older = await GetOlderNews("older");
                console.log("Older News:", older);
                setOlderNews(older);
            } catch (error) {
                console.error("Error in fetchOlderNews:", error);
            }
        };
    
        fetchOlderNews();
    }, []);
    
    

    return(
        <div className="all-components-container">
                <div className="component component-in-row-2">
                    <div className="component-heading">
                        Latest News
                    </div>
                    {latestNews && <NewsSection data={latestNews} />}
                </div>
                <div className="component-no-border component-in-row-2">
                    <div className="component-heading">
                        Our Portfolio Companies on Twitter
                    </div>
                    <SocialMediaSection twitterListId={PORTCO_TWITTER_LIST_ID} />
                </div>
                <div className="component component-in-row-2">
                    <div className="component-heading">
                        Older News
                    </div>
                    {olderNews && <NewsSection data={olderNews} />}
                </div>
                <div className="component-no-border component-in-row-2">
                    <div className="component-heading">
                    Our Founders on Twitter
                    </div>
                    <SocialMediaSection twitterListId={FOUNDER_TWITTER_LIST_ID} />
                </div>
        </div>
    );
}

export default Home;
